export const setStateParamsType = 'setStateParamsType';

export const stateParamsReducerKey = 'stateParams';
